import React, { FC } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../AuthProvider';
import { Loading } from '../../_common';
import { useStoreContext } from '../../App/StoreProvider';

interface PrivateRouteProps {
    children: React.ReactElement;
}

const PrivateRoute: FC<PrivateRouteProps> = ({ children }): React.JSX.Element => {
    const { userManager } = useAuthContext();
    const [{ auth }] = useStoreContext();
    const location = useLocation();

    if (auth.isUserLoading) {
        return <Loading />;
    }

    if (auth.user && !auth.user.expired) {
        return children;
    }

    userManager.removeUser();
    return <Navigate to="/" state={{ from: location }} replace />;
};

export default PrivateRoute;
